import { GREEN } from '../Theme/palette';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import React, { memo } from 'react';

import { CustomerSelect } from '@components';
import { L } from '@lib';
interface IProps {
  showAddButton?: boolean;
  disabled?: boolean;
  onClear?: () => void;
  onSelect?: ((value: string) => void) | undefined;
  onDeselect?: ((value: string) => void) | undefined;
  onAddClick?: React.MouseEventHandler<HTMLElement> | undefined;
}

export const CustomerAddSelect: React.FC<IProps> = memo(
  ({ showAddButton = false, disabled = false, onDeselect, onSelect, onAddClick, onClear }) => {
    return (
      <Row align="middle" gutter={8} wrap={false}>
        <Col flex="auto">
          <CustomerSelect
            disabled={disabled}
            notFoundText={showAddButton ? L('No customer found - use Add new') : undefined}
            onSelect={onSelect}
            onDeselect={onDeselect}
            onClear={onClear}
          />
        </Col>
        {showAddButton && (
          <Col flex="none">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              disabled={disabled}
              onClick={onAddClick}
              style={{ background: GREEN.badge, borderColor: GREEN.badge, minWidth: 110 }}
            >
              {L('Add new')}
            </Button>
          </Col>
        )}
      </Row>
    );
  }
);
